/**
 * Created by Arison on 19:48.
 * 充值列表和消费列表
 */
import React from 'react';
import ReactDOM from 'react-dom'
import Swiper from 'swiper/dist/js/swiper'
import './RechargeList.css'
import 'css/consume-re.css'
import { List,message,Skeleton,Icon} from 'antd';
import { connect } from 'react-redux'
import RefreshLayout from "../../components/RefreshLayout";
import {changeTabIndex} from "../../redux/actions/action";
import {fetchGet} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import {Toast} from "antd-mobile";


class RechargePayList extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'RechargeList',
            selectIndex:0,
            mConsumeIndex:0,
            mRechargeIndex:0,
            mPageSize:100,
            consumeList: [
                ],//消费记录
            rechargeList: [
            ],//充值记录
            isConsumeLoading: false,
            isRechargeLoading: false,
            isConsumeRefreshing: false,
            isRechargeRefreshing: false,
            height: document.documentElement.clientHeight,
        };
    }

    componentDidMount(){
        const hei = this.state.height - ReactDOM.findDOMNode(this.contain).offsetTop;
        this.setState({
            height: hei
        })
        document.title = '我的订单'
        const that=this;
        this.mySwiper = new Swiper('.swiper-container', {
            autoplay: false,
            loop: false,
            noSwiping: false,
            followFinger:false,//属性说明见：https://3.swiper.com.cn/api/touch/2014/1217/58.html
            initialSlide: that.state.selectIndex,
            on: {
                slideChangeTransitionEnd: function () {
                    that.setState({
                        selectIndex: this.activeIndex
                    })
                    if(this.activeIndex===0){
                        that.state.mConsumeIndex=0;
                        that.loadConsumeList();
                    }else{
                        that.state.mRechargeIndex=0;
                        that.loadRechargeList();
                    }
                }
            }
        })

        if (this.props.tabIndex >= 0) {
            this.setState({
                selectIndex: this.props.tabIndex
            }, () => {
                this.mySwiper.slideTo(this.state.selectIndex, 0, false);
            })
            if(this.props.tabIndex===0){
                this.state.mConsumeIndex=0;
                that.loadConsumeList();
            }else{
                this.state.mRechargeIndex=0;
                that.loadRechargeList();
            }
        }
    }

    onConsumeClick = () => {
        this.setState({
            selectIndex: 0
        }, () => {
            // message.info("点击消费记录"+mConsumeIndex)
            this.props.changeTabIndex(this.state.selectIndex)
            this.mySwiper.slideTo(this.state.selectIndex, 300, false)
            this.state.mConsumeIndex=0;
            this.loadConsumeList();
        })
    }

    onRechargeClick = () => {
        this.setState({
            selectIndex: 1
        }, () => {
            // message.info("点击充值记录"+mRechargeIndex)
            this.props.changeTabIndex(this.state.selectIndex)
            this.mySwiper.slideTo(this.state.selectIndex, 300, false)
            this.state.mRechargeIndex=0;
            this.loadRechargeList();
        })
    }

    render(){
        const {selectIndex}=this.state
        const consumeList = this.getConsumeList();
        const rechargeList = this.getRechargeList();
        return <div className="bg_white">
            <div className='identity-select'>
                <div className={selectIndex === 0 ?
                    'identity-item-select' : 'identity-item-normal'}
                     onClick={this.onConsumeClick}>交易记录
                </div>
                <div className={selectIndex === 1 ?
                    'identity-item-select' : 'identity-item-normal'}
                     onClick={this.onRechargeClick}>充值记录
                </div>
            </div>

            <div className="swiper-container  "
                 ref={el => {
                     this.contain = el
                 }}>
                <div className="swiper-wrapper   ">
                    <div className="swiper-slide ">
                        <div className='swiper-content '>
                            {consumeList}
                        </div>
                    </div>
                    <div className="swiper-slide ">
                        <div className='swiper-content '>
                            {rechargeList}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

   //消费记录
    getConsumeList=()=>{
       return (<div className='notify-bg-root'>
           <RefreshLayout
               ref={el => {
                   this.consumeTab = el
               }}
               refreshing={this.state.isConsumeRefreshing}
               onRefresh={this.loadConsumeList}
               height={this.state.height}>
               <Skeleton loading={this.state.isConsumeLoading} active paragraph={{rows: 3}}>
                   <List split={false}
                         dataSource={this.state.consumeList}
                         // style={{height:this.state.height}}
                         className="bg_white"
                         renderItem={(item, index) => (
                             <div>
                                 <div className="flex_row padding_10  bg_white">

                                     <div className="flex_column">
                                         <div className="span_14  text_bold">{item.inAmount>0?(<div>充值</div>)
                                             :(<div>消费</div>)}</div>
                                         <div className="color_gray">{item.time}</div>
                                     </div>
                                     {/*<div className="flex_center_vertical_end item_flex">
                                         {item.inAmount>0?(<div className="color_lightGreen">+{item.inAmount}元</div>)
                                             :(<div className="color_red">-{item.outAmount}元</div>)}
                                     </div>*/}
                                     <div className="item_flex1">
                                         <div className="color_lightGreen">{item.adress}</div>
                                         {item.inAmount>0?(<div className="color_lightGreen">+{item.inAmount}元</div>)
                                             :(<div className="color_red">-{item.outAmount}元</div>)}

                                     </div>

                                 </div>
                                 <div className="notify-item-line"></div>
                             </div>
                         )}/>
               </Skeleton>
           </RefreshLayout>

       </div>)
    }

    //充值记录
    getRechargeList=()=>{
        return (<div className='notify-bg-root'>
            <RefreshLayout
                ref={el => {
                    this.consumeTab = el
                }}
                refreshing={this.state.isRechargeRefreshing}
                onRefresh={this.loadRechargeList}
                height={this.state.height}>
                <Skeleton loading={this.state.isRechargeLoading} active paragraph={{rows: 3}}>
                    <List split={false}
                          dataSource={this.state.rechargeList}
                           className="bg_white"
                          // style={{height:this.state.height}}
                          renderItem={(item, index) => (
                             <div onClick={()=>{
                                 this.props.history.push('/rechargeDetail/'+item.id);
                             }}>
                                 <div className="flex_row padding_10  bg_white">

                                     <div className="flex_column">
                                         <div className="span_14  text_bold">充值{item.money}元</div>
                                         <div className="color_gray">{item.time}</div>
                                     </div>
                                     {/*<div  className="flex_center_vertical_end item_flex">
                                         {item.status=="充值成功"?(
                                             <div className="span_14 color_lightGreen">{item.status}</div>)
                                             :(<div className="span_14 color_red">{item.status}</div>)}

                                         <Icon type="right" />
                                     </div>*/}
                                     <div  className="flex_center_vertical_end item_flex">
                                         <div className="color_lightGreen">{item.chargeMethod}</div>
                                         <Icon type="right" />
                                     </div>

                                 </div>
                                 <div className="notify-item-line"></div>
                             </div>
                          )}/>
                </Skeleton>
            </RefreshLayout>
        </div>)
    }

     //加载消费数据
    loadConsumeList = () => {
        this.state.mConsumeIndex++;
        const {userInfo} = this.props
        if (userInfo.userRole === 1) {//家长
            console.log("loadConsumeList() mConsumeIndex:",this.state.mConsumeIndex);
            let stuId = "10097";
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.student != null) {
                    if (this.props.userInfo.parent.student.stuId != null) {
                        stuId = this.props.userInfo.parent.student.stuId;
                    }
                }
            }
            fetchGet(API.GET_CONSUME_LIST,{
                studentId:stuId,
                pageNumber:this.state.mConsumeIndex,
                pageSize:this.state.mPageSize
            }).then((response)=>{
                if(response.success){
                    if(this.state.mConsumeIndex === 1){
                        console.log("消费记录从第一页开始加载！");
                        this.state.consumeList.length = 0;
                    }else{
                        console.log("消费记录分页累加！");
                    }
                    let content =response.data.content;
                    if(content.length>0){
                        for(let i=0;i<content.length;i++){
                            let model={
                                inAmount:content[i].inAmount,
                                outAmount:content[i].outAmount,
                                time:content[i].sourceDate,
                                money:0,
                                adress:content[i].adress
                            };
                            this.state.consumeList.push(model)
                        }

                        this.setState({
                            consumeList:  this.state.consumeList,
                            isConsumeLoading: false,
                            isConsumeRefreshing: false,
                        })
                    }else{
                        this.setState({
                            isConsumeLoading: false,
                            isConsumeRefreshing: false,
                        })
                        Toast.info("数据加载完成！")
                    }

                }
            }).catch((error)=>{
                console.log("error:"+JSON.stringify(error));
            })
        }else{
            console.log("loadConsumeList() mConsumeIndex:",this.state.mConsumeIndex);
            fetchGet(API.GET_CONSUME_TEACHER_LIST,{
                teacherId:this.props.userInfo.user.userFunId,
                pageNumber:this.state.mConsumeIndex,
                pageSize:this.state.mPageSize
            }).then((response)=>{
                if(response.success){
                    if(this.state.mConsumeIndex === 1){
                        console.log("消费记录从第一页开始加载！");
                        this.state.consumeList.length = 0;
                    }else{
                        console.log("消费记录分页累加！");
                    }
                    let content =response.data.content;
                    if(content.length>0){
                        for(let i=0;i<content.length;i++){
                            let model={
                                inAmount:content[i].inAmount,
                                outAmount:content[i].outAmount,
                                time:content[i].sourceDate,
                                money:0
                            };
                            this.state.consumeList.push(model)
                        }

                        this.setState({
                            consumeList:  this.state.consumeList,
                            isConsumeLoading: false,
                            isConsumeRefreshing: false,
                        })
                    }else{
                        this.setState({
                            isConsumeLoading: false,
                            isConsumeRefreshing: false,
                        })
                        Toast.info("数据加载完成！")
                    }

                }
            }).catch((error)=>{
                console.log("error:"+JSON.stringify(error));
            })
        }


    }


    //加载充值数据
    loadRechargeList=()=>{
        this.state.mRechargeIndex++;
        const {userInfo} = this.props
        if (userInfo.userRole === 1) {//家长
            console.log("loadRechargeList() mRechargeIndex:",this.state.mRechargeIndex);
            let stuId = "10097";
            if (this.props.userInfo.parent != null) {
                if (this.props.userInfo.parent.student != null) {
                    if (this.props.userInfo.parent.student.stuId != null) {
                        stuId = this.props.userInfo.parent.student.stuId;
                    }
                }
            }
            fetchGet(API.GET_PAY_LIST,{
                studentId:stuId,
                pageNumber:this.state.mRechargeIndex,
                pageSize:this.state.mPageSize
            }).then((response)=>{
                // console.log("response:"+JSON.stringify(response));
                if(response.success){
                    if(this.state.mRechargeIndex ===1){
                        this.state.rechargeList.length = 0;
                    }
                    let content =response.data.content;
                    if(content.length>0){
                        for(let i=0;i<content.length;i++){
                            let assignStatus=""
                            if("NOT_ASSIGNED"===content[i].assignStatus){
                                assignStatus="未圈卡"
                            }else if ("ASSIGNED"===content[i].assignStatus){
                                assignStatus="充值成功"
                            }
                            let model={
                                id:content[i].id,
                                status:assignStatus,
                                time:content[i].payDate,
                                money:content[i].chargeAmount,
                                chargeMethod:content[i].chargeMethod
                            };
                            this.state.rechargeList.push(model);
                        }
                        this.setState({
                            rechargeList:this.state.rechargeList,
                            isRechargeLoading: false,
                            isRechargeRefreshing: false,
                        })
                    }else{
                        this.setState({
                            isRechargeLoading: false,
                            isRechargeRefreshing: false,
                        })
                        Toast.info("数据加载完成！")
                    }


                }

            }).catch((error)=>{
                console.log("error:"+JSON.stringify(error));
            })
        }else{
            console.log("loadRechargeList() mRechargeIndex:",this.state.mRechargeIndex);

            fetchGet(API.GET_PAY_TEACHER_LIST,{
                teacherId:this.props.userInfo.user.userFunId,
                pageNumber:this.state.mRechargeIndex,
                pageSize:this.state.mPageSize
            }).then((response)=>{
                // console.log("response:"+JSON.stringify(response));
                if(response.success){
                    if(this.state.mRechargeIndex ===1){
                        this.state.rechargeList.length = 0;
                    }
                    let content =response.data.content;
                    if(content.length>0){
                        for(let i=0;i<content.length;i++){
                            let assignStatus=""
                            if("NOT_ASSIGNED"===content[i].assignStatus){
                                assignStatus="未圈卡"
                            }else if ("ASSIGNED"===content[i].assignStatus){
                                assignStatus="充值成功"
                            }
                            let model={
                                id:content[i].id,
                                status:assignStatus,
                                time:content[i].payDate,
                                money:content[i].chargeAmount
                            };
                            this.state.rechargeList.push(model);
                        }
                        this.setState({
                            rechargeList:this.state.rechargeList,
                            isRechargeLoading: false,
                            isRechargeRefreshing: false,
                        })
                    }else{
                        this.setState({
                            isRechargeLoading: false,
                            isRechargeRefreshing: false,
                        })
                        Toast.info("数据加载完成！")
                    }


                }

            }).catch((error)=>{
                console.log("error:"+JSON.stringify(error));
            })
        }

    }
}




const mapStateToProps = state => ({
    tabIndex:state.appState.tabIndex,
    userInfo: {...state.redUserInfo}
})

const mapDispatchToProps = dispatch => ({
    changeTabIndex:(tabIndex)=>{
        dispatch(changeTabIndex(tabIndex));
    }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RechargePayList)
